module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('user-details', {
    ref: "userDetails",
    attrs: {
      "can-change-role": false
    }
  }, [_c('div', {
    slot: "cropper"
  }, [_c('photo-cropper', {
    attrs: {
      "name": "driver",
      "photo-storage-path": _vm.accountUser.driver_profile.photo_storage_path,
      "original-name": _vm.accountUser.driver_profile.photo_name,
      "original-data-uri": _vm.originalPhotoDataUri,
      "class-name": "profile-photo",
      "label-text": "Profile Photo"
    },
    model: {
      value: (_vm.photo),
      callback: function($$v) {
        _vm.photo = $$v
      },
      expression: "photo"
    }
  })], 1)]), _vm._v(" "), _c('ladda-button', {
    staticClass: "btn btn-success",
    attrs: {
      "on-click": _vm.saveAccountUser
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Save")]), _vm._v(" "), _c('div', {
    staticClass: "decorative-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "margin-50"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-0b1f324a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/drivers/Form.vue
// module id = 927
// module chunks = 0